import { render } from "./DecisionToggle.vue?vue&type=template&id=bf1a21a8"
import script from "./DecisionToggle.vue?vue&type=script&lang=js"
export * from "./DecisionToggle.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__